import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Head from '../../hocs/Head/Head';
// import { route } from 'preact-router';
import SideMenu from '../SideMenu/SideMenu';
import Slider from '../Slider/Slider';
import Shop from '../Shop/Shop';
import Text from '../Text/Text';
import { addClass, removeClass, width } from '../../utils/dom';
import s from './TextPage.scss';

class TextPage extends Component {
	static updateBody(match) {
		if (typeof window !== 'undefined') {
			const $body = document.querySelector('body');

			if (match.path === '*') {
				removeClass($body, '');
				addClass($body, 'is-startPage');
			} else if (match.path === '/shop') {
				removeClass($body, '');
				addClass($body, 'is-shopPage');
			} else if (match.path === '/:page') {
				removeClass($body, '');
				addClass($body, 'is-textPage');
			}
		}
	}

	static contentKey(match) {
		let contentKey = 'start';
		if (match.path === '/shop') contentKey = 'shop';
		if (match.path === '/:page') contentKey = match.params.page;
		return contentKey;
	}

	static fetchData(props) {
		const { match, pages, getPage } = props;
		const contentKey = TextPage.contentKey(match);

		return (!pages[contentKey]) ? getPage(contentKey) : null;
	}

	componentDidMount() {
		const { match, pages } = this.props;

		TextPage.fetchData(this.props);
		TextPage.updateBody(match, pages);
		if (match.path === '/shop') this.props.updatePreviousPage('/shop');
	}

	componentWillReceiveProps({ match, pages, getPage, setup }) {
		if (match.path === '*' && setup.siteClosed !== undefined && setup.siteClosed === true) {
			getPage('start');
		}
		TextPage.updateBody(match, pages);
	}

	shouldComponentUpdate({ match, pages, getPage }) {
		const contentKey = TextPage.contentKey(match);

		if (!pages[contentKey]) {
			getPage(contentKey);
			if (width(window) < 600) {
				return true;
			}
			return false;
		}
		return true;
	}

	componentDidUpdate() {
		if (this.props.match.path === '/shop') this.props.updatePreviousPage('/shop');
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined') {
			removeClass(document.querySelector('body'), '');
		}
	}

	render() {
		if (this.props.match.path !== '*' && this.props.setup.siteClosed === true) return <Redirect to="/" />;
		if (this.props.match.path === '*' && this.props.setup.siteClosed === true) return null;
		if (this.props.pages === undefined) return null;
		const { setup, match, pages, changeSlide, windowDimensions, win, navigation, toggleSideMenu, filterProducts, closeSideMenu, previousPage } = this.props;
		const contentKey = TextPage.contentKey(match);
		if (!pages[contentKey]) return null;
		const content = pages[contentKey].content;
		const contentClasses = [s.content];
		if (navigation.sideMenuOpen) contentClasses.push(s.content__mobileMenuOpen);

		const metaDescriptionFallback = setup.meta ? setup.meta.siteDescription : '';

		let declarationMenu;
		let template;

		switch (content.template) {
			case 'start_slider':
				template = <Slider content={content} contentKey={contentKey} changeSlide={changeSlide} windowDimensions={windowDimensions} win={win} />;
				break;
			case 'shop':
				template = <Shop shop={content.shop} title={content.title} />;
				break;
			case 'text_page': {
				const sideMenuPage = navigation.sideMenu ? navigation.sideMenu.map(link => link.URI).indexOf(match.params.page) !== -1 : false;
				template = <Text textPage={content.textPage} title={content.title} contentKey={contentKey} setup={setup} sideMenuPage={sideMenuPage} pagePath={match.params.page} previousPage={previousPage} />;
				break;
			}
			default:
				template = <div />;
		}

		return (
			<main className={[s.textPage, s[`textPage__${content.template}`]].join(' ')} role="main">
				<Head>
					<title>{setup.meta && setup.meta.prefixTitle ? setup.meta.prefixTitle : ''} {content.title} {setup.meta && setup.meta.suffixTitle ? setup.meta.suffixTitle : ''}</title>
					<meta name="description" content={content.metaDescription ? content.metaDescription : metaDescriptionFallback} />
				</Head>
				{ match.path !== '*' ? <SideMenu navigation={navigation} declarationMenu={declarationMenu} toggleSideMenu={toggleSideMenu} staticTexts={setup.static} filterProducts={filterProducts} closeSideMenu={closeSideMenu} /> : null }
				<div className={contentClasses.join(' ')}>
					{template}
				</div>
			</main>
		);
	}
}

export default TextPage;



// WEBPACK FOOTER //
// ./components/TextPage/TextPage.jsx